import { render, staticRenderFns } from "./editPropertyRightRegistration.vue?vue&type=template&id=6fb55e08&scoped=true"
import script from "./editPropertyRightRegistration.vue?vue&type=script&lang=js"
export * from "./editPropertyRightRegistration.vue?vue&type=script&lang=js"
import style0 from "./editPropertyRightRegistration.vue?vue&type=style&index=0&id=6fb55e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb55e08",
  null
  
)

export default component.exports